module.exports = __webpack_public_path__ + "static/media/rran_logo_dark_bg.1a6e463f.png";